import { Handle, Position } from '@xyflow/react';
import { Eye, EyeOff } from 'lucide-react';

const getStateStyle = (published, weight) => {
  if (published) {
    return {
      bg: 'bg-emerald-50',
      border: 'border-emerald-500',
      text: 'text-emerald-800',
      handle: 'transparent',
      badge: 'bg-emerald-100 text-emerald-700',
      badgeLabel: 'Publié',
    };
  }
  if (weight >= 900) {
    return {
      bg: 'bg-red-50',
      border: 'border-red-400',
      text: 'text-red-800',
      handle: 'transparent',
      badge: 'bg-red-100 text-red-700',
      badgeLabel: 'Non publié',
    };
  }
  return {
    bg: 'bg-slate-50',
    border: 'border-slate-400',
    text: 'text-slate-700',
    handle: 'transparent',
    badge: 'bg-slate-100 text-slate-500',
    badgeLabel: 'Non publié',
  };
};

// Invisible handles kept for edge routing only — no interactive connection UI.
const HANDLE_DEFS = [
  { id: 'source-top',    type: 'source', position: Position.Top    },
  { id: 'source-right',  type: 'source', position: Position.Right  },
  { id: 'source-bottom', type: 'source', position: Position.Bottom },
  { id: 'source-left',   type: 'source', position: Position.Left   },
  { id: 'target-top',    type: 'target', position: Position.Top    },
  { id: 'target-right',  type: 'target', position: Position.Right  },
  { id: 'target-bottom', type: 'target', position: Position.Bottom },
  { id: 'target-left',   type: 'target', position: Position.Left   },
];

const INVISIBLE_HANDLE = {
  width: 8,
  height: 8,
  border: 'none',
  borderRadius: '50%',
  background: 'transparent',
  opacity: 0,
  pointerEvents: 'none',
};

export function StateNode({ data, selected }) {
  const { label, published, weight, stateId } = data;
  const style = getStateStyle(published, weight);

  return (
    <div
      className={`
        relative rounded-lg border-2 shadow-md min-w-[160px] transition-all duration-150
        ${style.bg} ${style.border}
        ${selected ? 'ring-2 ring-offset-2 ring-iris-500 shadow-lg' : ''}
      `}
    >
      <span
        title={style.badgeLabel}
        className={`absolute top-1.5 right-1.5 flex items-center justify-center w-5 h-5 rounded-full ${style.badge}`}
      >
        {published
          ? <Eye size={11} strokeWidth={2.5} />
          : <EyeOff size={11} strokeWidth={2.5} />
        }
      </span>

      {HANDLE_DEFS.map(({ id, type, position }) => (
        <Handle
          key={id}
          id={id}
          type={type}
          position={position}
          isConnectable={false}
          style={INVISIBLE_HANDLE}
        />
      ))}

      <div className="px-4 py-3">
        <div className={`font-bold text-sm uppercase tracking-wide text-center ${style.text}`}>
          {label || stateId}
        </div>
      </div>
    </div>
  );
}
